import React from 'react';

export default function LiveBadge({ text = 'Şu An Aktif', size = 'default', style = {} }) {
  const isSmall = size === 'small';
  return (
    <div
      data-testid="live-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isSmall ? '.3rem' : '.4rem',
        background: 'var(--green-dim)',
        border: '1px solid var(--green-border)',
        borderRadius: 100,
        padding: isSmall ? '.2rem .625rem' : '.28rem .875rem',
        fontSize: isSmall ? '.62rem' : '.67rem',
        fontWeight: 700,
        letterSpacing: '.07em',
        textTransform: 'uppercase',
        color: 'var(--green)',
        ...style,
      }}
    >
      <span
        className="live"
        style={{
          width: isSmall ? 5 : 6,
          height: isSmall ? 5 : 6,
          borderRadius: '50%',
          background: 'var(--green)',
          display: 'inline-block',
        }}
      />
      {text}
    </div>
  );
}
